import React from "react";
import styled, { css } from "styled-components";
import { SpinnerIcon } from "tombac-icons";
import { propStyling, tombac } from "../../../shared";
export const spinnerStyles = css(["color:", ";left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);", ""], _ref => {
  var _theme$components$but;
  let {
    theme
  } = _ref;
  return tombac.parse((_theme$components$but = theme.components.button.current) === null || _theme$components$but === void 0 ? void 0 : _theme$components$but.color);
}, propStyling);
const Container = styled.span.withConfig({
  displayName: "Spinner__Container"
})(["", ""], spinnerStyles);
export const Spinner = props => /*#__PURE__*/React.createElement(Container, {
  "aria-hidden": true
}, /*#__PURE__*/React.createElement(SpinnerIcon, {
  spin: true
}));
//# sourceMappingURL=Spinner.js.map